import React from 'react';
import { useForm } from 'react-hook-form';
import { usePharmacy } from '../context/PharmacyContext';
import { motion } from 'framer-motion';

function PrescriptionRefills() {
  const { register, handleSubmit, reset } = useForm();
  const { refills, setRefills } = usePharmacy();

  const onSubmit = (data) => {
    setRefills([...refills, data]);
    reset();
  };

  return (
    <motion.div initial={{ x: '-100vw' }} animate={{ x: 0 }} exit={{ x: '100vw' }}>
      <h2>Prescription Refills</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input {...register('medication')} placeholder="Medication Name" required />
        <input {...register('pharmacy')} placeholder="Pharmacy Name" required />
        <button type="submit">Request Refill</button>
      </form>
      <ul>
        {refills.map((refill, index) => (
          <li key={index}>{refill.medication} from {refill.pharmacy}</li>
        ))}
      </ul>
    </motion.div>
  );
}

export default PrescriptionRefills;
